import { useParams } from 'react-router-dom';

function RedirectToNextCanvas() {
  const { id } = useParams() as { id: string };
  window.location.replace(`${process.env.REACT_APP_NEXT_URL}/canvas/${id}`);
  return null;
}

export default RedirectToNextCanvas;
